import React, { useState } from 'react';
import { CheckIcon, LoaderIcon, RotateCwIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface ResendLinkProps {
  email: string;
  variant?: 'primary' | 'secondary';
}

/**
 * A resend that visibly works: it acknowledges, shows a result with a
 * timestamp, and then allows another attempt. Never a silent no-op.
 */
export function ResendLink({
  email,
  variant = 'secondary'
}: ResendLinkProps) {
  const [state, setState] = useState<'idle' | 'sending' | 'sent'>('idle');
  const [count, setCount] = useState(0);
  const [at, setAt] = useState('');
  function send() {
    setState('sending');
    window.setTimeout(() => {
      setState('sent');
      setCount(current => current + 1);
      setAt(new Date().toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit'
      }).toLowerCase());
    }, 900);
  }
  return <div className="flex flex-col gap-2" data-id="element-103" data-mp="1nxbm3y5pcmez">
      <Button variant={variant} onClick={send} disabled={state === 'sending'} data-id="element-104" data-mp="1j0bdbfhgx5k6">
        {state === 'sending' ? <>
            <LoaderIcon aria-hidden="true" className="h-4 w-4 animate-spin" data-id="element-105" data-mp="n7ivagkk4e3t" />
            Sending…
          </> : state === 'sent' ? <>
            <RotateCwIcon aria-hidden="true" className="h-4 w-4" data-id="element-106" data-mp="dbfupf5csniz" />
            Send it again
          </> : <>
            <RotateCwIcon aria-hidden="true" className="h-4 w-4" data-id="element-107" data-mp="ia97t6gqacim" />
            Resend the link
          </>}
      </Button>

      <p aria-live="polite" className="text-small text-ink-muted" data-id="element-108" data-mp="161o5un1h27o2">
        {state === 'sent' ? <span className="flex items-center gap-1.5 text-ink" data-id="element-109" data-mp="1b07uiv7g9xk4">
            <CheckIcon aria-hidden="true" className="h-4 w-4 text-primary-text" data-id="element-110" data-mp="w8z5an7gme7i" />
            {count > 1 ? `Sent again` : 'Sent'} to {email} at {at}. Give it a minute, it can be
            slow.
          </span> : ''}
      </p>
    </div>;
}